import { DecodeHtml } from '../../utils/decodeHtml'
import { retrunAssets } from '../../utils/getAssets'
import WelcomeIc from './welcomeIc'

const ICSection = ({ internationalOffice }) => {
  const iCActivitiesImage =
    internationalOffice?.iCActivitiesImage != null
      ? retrunAssets(internationalOffice?.iCActivitiesImage[0]?.url)
      : ''

  const iCActivePartnersTitle = internationalOffice?.iCActivePartnersTitle
  const iCActivePartnersContents =
    internationalOffice?.iCActivePartnersContents?.markup
  return (
    <div className='flex justify-center p-4 md:py-8 w-full'>
      <div className='flex flex-col gap-5 lg:px-16 w-full'>
        <WelcomeIc internationalOffice={internationalOffice} />
        <div
          className='w-full  h-[40rem] bg-center bg-gray-100 rounded  bg-cover bg-no-repeat'
          style={{ backgroundImage: `url('${iCActivitiesImage}')` }}
        ></div>
        <h1 className='text-2xl text-slate-900 font-semibold  2xl:text-3xl '>
          {iCActivePartnersTitle}
        </h1>
        {iCActivePartnersContents &&
          DecodeHtml({ html: iCActivePartnersContents })}
      </div>
    </div>
  )
}

export default ICSection
